import Checkbox from "pages/ManagementPage/candidateInfoForm/Checkbox/Checkbox";

export default Checkbox;
